<input
  type="file"
  class="file-input"
  [accept]="requiredFileType"
  (change)="onFileSelected($event)"
  #fileUpload
/>
<div fxFlexLayout="row" fxLayoutGap="4" class="file-upload">
  <div fxLayout="column">
  <label fxFlex="initial" class="title">{{ config.label }}:</label>
  <label fxFlex="initial" class="comment-title">{{ getComment() }}</label>
</div>

  <label *ngIf="fileName && typeCes == typeCesEnum.SHOW" fxFlex class="value">
    <a [href]="downloadFile()" target="_blank">{{ fileName }}</a>
  </label>
  <label
    *ngIf="fileName && typeCes != typeCesEnum.SHOW"
    fxFlex
    class="value"
    (click)="fileUpload.click()"
  >
    {{ fileName }}
  </label>
  <label *ngIf="!fileName" fxFlex class="value">{{
    messagesEnum.NO_FILE_UPLOADED_YET
  }}</label>

  <button
    *ngIf="!fileName && typeCes !== typeCesEnum.SHOW"
    fxFlex="initial"
    mat-mini-fab
    color="primary"
    class="upload-btn"
    (click)="fileUpload.click()"
  >
    <mat-icon>attach_file</mat-icon>
  </button>
  <button
    *ngIf="fileName && typeCes !== typeCesEnum.SHOW"
    fxFlex="initial"
    mat-mini-fab
    color="primary"
    class="upload-btn"
    (click)="cancelFile()"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>
